import { type MouseEvent as ReactMouseEvent, useCallback, useMemo } from 'react';

import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { useCAForCard } from '@/microfrontends/listing/shared/hooks/card/useCAForCard';
import { formatPhone } from '@/microfrontends/listing/shared/utils/formatPhone';

import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';
import { memoWithDisplayName } from '@/packages/utils';

import { PhoneButton } from './componentns/PhoneButton';
import { type DisplayPhonesOptions } from './types';

type HandleClick = (event: ReactMouseEvent<HTMLElement>) => void;

type PhoneButtonContainerProps = {
  displayPhonesOptions?: DisplayPhonesOptions;
};

export const CardContactsButtonDesktopContainer = memoWithDisplayName<PhoneButtonContainerProps>(props => {
  const { phones, workHours } = useCardOfferPublisherContext();
  const { data: user } = useUserQuery();
  const displayPhonesOptions = useMemo<DisplayPhonesOptions>(() => {
    return (
      props.displayPhonesOptions || {
        countToDisplay: phones.length,
        shouldDisplayWorkHours: true,
      }
    );
  }, [props.displayPhonesOptions, phones]);

  const caForCard = useCAForCard();

  const handleClick = useCallback<HandleClick>(() => {
    caForCard(
      { action: user?.isAgent ? 'Open_listing_agent_block' : 'Open_listing', category: 'Phones' },
      { label: true },
    );
  }, [caForCard, user]);

  const prettyPhones = phones.map(formatPhone);
  const prettyWorkHours = workHours ? `Работает с ${workHours.workFrom} до ${workHours.workTo}` : null;

  return (
    <PhoneButton
      displayPhonesOptions={displayPhonesOptions}
      phones={prettyPhones}
      workHours={prettyWorkHours}
      onPhonesShow={handleClick}
    />
  );
}, 'PhoneButtonContainer');
